/* eslint-disable react-hooks/exhaustive-deps */
import { LikeOutlined, DislikeOutlined } from "@ant-design/icons";
import { Modal, Table, Tag, Input, Empty } from "antd";
import dayjs from "dayjs";
import { useState, useEffect } from "react";

const HintFeedbackModal = ({ isModalOpen = false, sectionsData, setIsModalOpen = () => {} }) => {
  const [allCourseHints, setAllCourseHints] = useState([]);
  const [filteredHints, setFilteredHints] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10
    }
  });

  useEffect(() => {
    let index = 1;
    const hintsData = (sectionsData || []).flatMap((sectionData) => {
      const sectionDescription = sectionData?.sectionDetails?.description;
      return (sectionData?.tasks || []).map((task) => ({
        ...task,
        index: index++,
        sectionDescription
      }));
    });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: hintsData.length
      }
    });
    setAllCourseHints(hintsData);
    setFilteredHints(hintsData);
  }, [sectionsData]);

  const handleSearch = (value) => {
    setSearchValue(value);

    const filteredData = allCourseHints?.filter((hint) =>
      hint?.title?.toLowerCase().includes(value.toLowerCase())
    );
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        total: filteredData.length
      }
    });
    setFilteredHints(filteredData);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field
    });

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setAllCourseHints([]);
    }
  };

  const columns = [
    { title: "S.No.", dataIndex: "index", key: "index", width: 70 },
    {
      title: "Week Name",
      dataIndex: "sectionDescription",
      key: "sectionDescription",
      ellipsis: true
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      ellipsis: true
    },
    {
      title: "Platform",
      dataIndex: "category",
      key: "category"
    },
    {
      title: "Day in Week",
      dataIndex: "dayNumber",
      key: "dayNumber",
      width: 150
    },
    {
      title: "Hint updated At",
      dataIndex: "hintUpdatedAt",
      key: "hintUpdatedAt",
      render: (hintUpdatedAt) =>
        hintUpdatedAt ? dayjs(hintUpdatedAt).format("DD MMM YYYY | HH:mm") : "--"
    },
    {
      title: "Hint Likes",
      key: "hintLikes",
      dataIndex: "totalLikes",
      render: (totalLikes) => (
        <div style={{ display: "flex" }}>
          <Tag color="green" key="like">
            <LikeOutlined />
            {totalLikes || 0}
          </Tag>
        </div>
      ),
      width: 125,
      sorter: (a, b) => (a.totalLikes || 0) - (b.totalLikes || 0)
    },
    {
      title: "Hint Dislikes",
      key: "hintDikes",
      dataIndex: "totalDislikes",
      render: (totalDislikes) => (
        <div style={{ display: "flex" }}>
          <Tag color="red" key="dislike">
            <DislikeOutlined />
            {totalDislikes || 0}
          </Tag>
        </div>
      ),
      width: 150,
      sorter: (a, b) => (a.totalDislikes || 0) - (b.totalDislikes || 0)
    }
  ];

  return (
    <Modal
      title="Hints Feedback"
      centered
      open={isModalOpen}
      footer={null}
      onOk={() => setIsModalOpen(false)}
      onCancel={() => setIsModalOpen(false)}
      width={"90vw"}
    >
      <Input.Search
        placeholder="Enter task name to search"
        value={searchValue}
        onChange={(e) => handleSearch(e.target.value)}
        style={{ marginBottom: 20, width: "50%" }}
        allowClear
      />

      {filteredHints.length > 0 ? (
        <Table
          columns={columns}
          dataSource={filteredHints}
          rowKey="hintId"
          pagination={tableParams.pagination}
          onChange={handleTableChange}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <Empty description="No matching hints found" />
      )}
    </Modal>
  );
};

export default HintFeedbackModal;
